










import Vue from 'vue';
export default Vue.extend({
  props: ["max", "min", "default"],
  data() {
      return {
          
      }
  },
  methods: {
      add: function() {
          this.$emit('scale', '+');
      },
      subtract: function(){
          this.$emit('scale', '-');
      }
  }

});
